import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const MaintenanceBoard = lazy(() => import('./MaintenanceBoard'));
const AcquisitionDashboard = lazy(() => import('./AcquisitionDashboard'));
const WarrantyManager = lazy(() => import('./WarrantyManager'));
const InspectionMeterPanel = lazy(() => import('./InspectionMeterPanel'));
const AssetAcquisitionRequests = lazy(() => import('./AssetAcquisitionRequests'));
const AssetCapitalization = lazy(() => import('./AssetCapitalization'));
const AssetDisposals = lazy(() => import('./AssetDisposals'));
const AssetTransfers = lazy(() => import('./AssetTransfers'));
const AssetCategories = lazy(() => import('./AssetCategories'));

export const eamRoutes = (
  <>
    <Route element={<ProtectedRoute requiredPermission="eam.maintenance.view" />}>
      <Route path="/eam/maintenance" element={<MaintenanceBoard />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.acquisition.view" />}>
      <Route path="/eam/acquisition" element={<AcquisitionDashboard />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.warranty.view" />}>
      <Route path="/eam/warranty" element={<WarrantyManager />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.inspection.view" />}>
      <Route path="/eam/inspection" element={<InspectionMeterPanel />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.acquisition.view" />}>
      <Route path="/eam/acquisition-requests" element={<AssetAcquisitionRequests />} />
      <Route path="/eam/capitalization" element={<AssetCapitalization />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.disposal.view" />}>
      <Route path="/eam/disposals" element={<AssetDisposals />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.transfer.view" />}>
      <Route path="/eam/transfers" element={<AssetTransfers />} />
    </Route>
    <Route element={<ProtectedRoute requiredPermission="eam.category.view" />}>
      <Route path="/eam/categories" element={<AssetCategories />} />
    </Route>
  </>
);
